import Script from 'next/script';

const Pinterest = () => <Script async defer src="//assets.pinterest.com/js/pinit.js" type="text/javascript" />;

export default Pinterest;
